export default function Hero() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>

      <div className="relative w-full px-4 md:px-6 py-24 md:py-20">
        <div className="w-full flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-6">
              <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
              <span>热播推荐 · 每日更新</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-foreground-950 leading-tight font-heading">
              向日葵视频
              <span className="block text-primary-600 mt-1">免费高清在线观看平台</span>
            </h1>

            <p className="mt-4 text-lg md:text-xl text-foreground-600 font-medium">
              榴莲视频、红杏视频等海量热播资源，流畅不缓冲
            </p>

            <p className="mt-6 text-sm md:text-base text-foreground-500 leading-relaxed max-w-2xl mx-auto lg:mx-0">
              向日葵视频汇集榴莲视频、红杏视频等平台最新最全的电影、电视剧、综艺、
              动漫资源，全部免费高清在线观看。每日同步更新热门剧集，支持多线路切换，
              播放流畅不卡顿，为您带来极致的在线播放体验。无论追剧还是观影，
              向日葵视频都是你的最佳选择。
            </p>

            <div className="mt-8 flex flex-wrap items-center justify-center lg:justify-start gap-6">
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-100/80">
                  <i className="ri-fire-line text-accent-600 text-sm"></i>
                </span>
                <div className="text-left">
                  <div className="text-lg font-bold text-foreground-900">10万+</div>
                  <div className="text-xs text-foreground-500">影视资源</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-secondary-100/80">
                  <i className="ri-flashlight-line text-secondary-600 text-sm"></i>
                </span>
                <div className="text-left">
                  <div className="text-lg font-bold text-foreground-900">极速不缓冲</div>
                  <div className="text-xs text-foreground-500">多线路保障</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-100/80">
                  <i className="ri-timer-line text-primary-600 text-sm"></i>
                </span>
                <div className="text-left">
                  <div className="text-lg font-bold text-foreground-900">每日更新</div>
                  <div className="text-xs text-foreground-500">同步热播</div>
                </div>
              </div>
            </div>

            <div className="mt-10 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <a
                href="#index"
                onClick={(e) => handleNavClick(e, '#index')}
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 font-semibold rounded-full text-sm hover:bg-primary-600 transition-colors text-center whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line mr-2"></i>
                立即观影
              </a>
              <a
                href="#features"
                onClick={(e) => handleNavClick(e, '#features')}
                className="w-full sm:w-auto px-8 py-3.5 border border-background-300 text-foreground-700 font-medium rounded-full text-sm hover:bg-background-100 hover:border-primary-300 transition-colors text-center whitespace-nowrap cursor-pointer"
              >
                了解更多
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[520px]">
              <div className="absolute -inset-4 bg-gradient-to-br from-primary-400/20 via-accent-300/15 to-secondary-400/20 rounded-2xl blur-2xl"></div>
              <div className="relative rounded-2xl overflow-hidden bg-background-100 border border-background-200/60">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20video%20streaming%20platform%20interface%20with%20warm%20orange%20and%20amber%20gradient%20background%2C%20showing%20movie%20thumbnails%20grid%20with%20play%20buttons%2C%20cinematic%20atmosphere%2C%20clean%20UI%20design%2C%20dark%20overlay%20with%20warm%20accents%2C%20entertainment%20theme%2C%20high%20quality%20digital%20art%2C%20streaming%20service%20homepage%20mockup%20with%20film%20posters%2C%20polished%20professional%20look%2C%20no%20text%20visible&width=1040&height=780&seq=hero-main-visual-2026&orientation=landscape"
                  alt="向日葵视频在线播放平台界面展示"
                  className="w-full h-auto object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
                <div className="absolute bottom-4 left-4 right-4 flex items-center gap-3">
                  <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500/90 backdrop-blur-sm cursor-pointer">
                    <i className="ri-play-fill text-background-50 text-lg ml-0.5"></i>
                  </span>
                  <div className="flex-1">
                    <div className="h-1.5 bg-background-50/30 rounded-full overflow-hidden">
                      <div className="h-full w-[45%] bg-primary-500 rounded-full"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}